import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'
import heroWebp3x from './assets/Hero@3x.webp'

const copy = {
  overline: `Mobile`,
  heading: `Power customer analytics and mobile marketing with a single SDK`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => (
  <Wrapper>
    <StyledHeroBase variant="2Col">
      <HeroRecipe.Copy>
        <CopyText.Overline tag="h5" variant="h5">
          {copy.overline}
        </CopyText.Overline>
        <CopyText.Heading variant="h1" tag="h1">
          {copy.heading}
        </CopyText.Heading>
        <HeroRecipe.Form>
          <StyledDemoForm isProgressive={true} customFormIdentifier="site-industry-mobile-demo" />
        </HeroRecipe.Form>
      </HeroRecipe.Copy>
      <HeroRecipe.Contents>
        <Picture>
          <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x, ${heroWebp3x} 3x`} />
          <HeroRecipe.Image width="779" height="526" src={heroPng2x} alt="Hero" loading="lazy" />
        </Picture>
      </HeroRecipe.Contents>
    </StyledHeroBase>
  </Wrapper>
)

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      text-align: left;
    }
  }
`

const StyledDemoForm = styled(DemoForm)`
  margin-top: 40px;
`

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default Hero
